import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import Address from '@/components/UI/Address';
import EventDate from '@/components/UI/EventDate';
import Link from '@/components/UI/Link';
// import MusicBadges from '@/components/UI/MusicBadges';
import HomeSvg from '@/public/icon/home.svg';
import { Event } from '@/types/event';
import { PlaceMusicCategory } from '@/types/placeMusicCategory';
import Routes from '@/utils/routes';

interface EventPageHeroSectionProps {
  event: Event;
  place: any;
  musics: PlaceMusicCategory[];
  className?: string;
}

export default function EventPageHeroSection({
  event,
  place,
  musics,
  className = '',
}: EventPageHeroSectionProps) {
  const t = useTranslations('Pages.Event.EventPageHeroSection');

  return (
    <section className={clsx('', className)}>
      <h1 className='text-3xl font-bold text-white-filled-default'>
        {event.name}
      </h1>
      <div className='mt-1 flex space-x-1 font-extrabold text-white-filled-default'>
        <p className='text-out-gray'>{t('by')}</p>
        <Link
          variant='link'
          href={Routes.Place(place.id)}
          padding='none'
          color='white'
        >
          {place.name}
        </Link>
      </div>
      <div className='space-y-6 divide-y divide-neutral-faded-default'>
        <div className='mt-6 space-y-6 font-medium text-white-filled-default'>
          <EventDate
            startDate={new Date(event.dateFrom)}
            endDate={event.dateTo ? new Date(event.dateTo) : null}
          />
          <div className='flex items-center space-x-2'>
            <HomeSvg />
            <p>{place.name}</p>
          </div>
          <Address place={event.address ? event : place} />
        </div>
        {/* {!!(musics && musics.length > 0) && (
          <MusicBadges className='pt-6' musics={musics} />
        )} */}
      </div>
    </section>
  );
}
